import Icon from '@components/svg/SearchSvg'
import { minWidthQueries } from '@operations/utils/useMediaQuery'
import React from 'react'
import styled from 'styled-components'

const StyledSearchForm = styled.form`
  padding: 1rem 2rem;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &:before {
    content: '';
    position: absolute;
    left: -85px;
    top: 0;
    width: 80px;
    height: 80px;
    background: ${({ theme }) => theme.colors.gold};
    clip-path: polygon(
      0% 0%,
      100% 0%,
      75% 26%,
      52% 25%,
      47% 28%,
      45% 33%,
      47% 38%,
      50% 40%,
      66% 43%,
      50% 63%
    );
    transform: scaleX(-1);
  }
  &:after {
    content: '';
    position: absolute;
    right: -85px;
    top: 0;
    width: 80px;
    height: 80px;
    background: ${({ theme }) => theme.colors.gold};
    clip-path: polygon(
      0% 0%,
      100% 0%,
      75% 26%,
      52% 25%,
      47% 28%,
      45% 33%,
      47% 38%,
      50% 40%,
      66% 43%,
      50% 63%
    );
  }
  @media ${minWidthQueries.md} {
    padding: 1.5rem 7rem;
  }
`
const SearchFormBg = styled.div`
  position: absolute;
  left: 0;
  top: -5px;
  width: 100%;
  height: 100%;
  background: black;
  transform: perspective(12px) rotateX(2deg);
  z-index: 1;
  &:after {
    content: '';
    position: absolute;
    right: -20px;
    top: 0;
    width: 15px;
    height: 100%;
    z-index: 1;
    background: ${({ theme }) => theme.colors.teal};
  }
  &:before {
    content: '';
    position: absolute;
    left: -20px;
    top: 0;
    width: 15px;
    height: 100%;
    z-index: 1;
    background: ${({ theme }) => theme.colors.teal};
  }
`
const SearchField = styled.input`
  border-radius: ${({ theme }) => theme.borderRadius}px;
  padding: 0.5rem 1rem;
  border: 1px solid white;
  width: 250px;
  margin-right: 0.5rem;
  position: relative;
  z-index: 2;
`
export const SearchFieldButton = styled.button`
  background: ${({ theme }) => theme.colors.gold};
  border: 1px solid ${({ theme }) => theme.colors.gold};
  padding: 0.5rem 0.75rem;
  border-radius: ${({ theme }) => theme.borderRadius}px;
  height: 100%;
  transition: all 0.2s ease;
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    width: 20px;
    fill: ${({ theme }) => theme.colors.white};
  }
  &:hover {
    opacity: 0.8;
    cursor: ${({ theme }) => theme.cursor.pointer};
  }
`

const SearchForm = ({ onSubmit, setSearchValue, searchValue }) => {
  return (
    <StyledSearchForm
      onSubmit={e => {
        e.preventDefault()
        onSubmit(e)
      }}
    >
      <SearchFormBg />
      <SearchField
        placeholder="Search by name or number"
        type="search"
        value={searchValue}
        onChange={e => setSearchValue(e.target.value)}
      />
      <SearchFieldButton type="submit">
        <Icon />
      </SearchFieldButton>
    </StyledSearchForm>
  )
}

export default SearchForm
